import { forwardRef, createElement } from 'react';

function IconTag(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M10.356 2c.464 0 .909.184 1.237.513l9.92 9.919a1.75 1.75 0 010 2.475l-6.606 6.606a1.75 1.75 0 01-2.475 0l-9.92-9.92A1.75 1.75 0 012 10.356V3.75C2 2.784 2.784 2 3.75 2h6.606zm0 1.5H3.75a.25.25 0 00-.243.193L3.5 3.75v6.606a.25.25 0 00.033.125l.04.051 9.92 9.92a.25.25 0 00.3.04l.053-.04 6.606-6.606a.25.25 0 00.04-.3l-.04-.053-9.92-9.92a.25.25 0 00-.111-.064l-.065-.009zm1.57 5.394c.365-.007.652.086.852.287.256.255.225.645-.02.89-.215.215-.453.322-.78.366-.512.07-.826.211-1.13.515-.335.335-.335.742-.114.963.203.203.484.176.923-.106l.123-.084.715-.5c1.04-.729 1.934-.732 2.666 0 .809.809.81 1.956.044 3.041l-.12.163.155.155c.238.238.128.494-.02.642-.14.14-.364.246-.581.093l-.072-.062-.145-.145c-.615.532-1.285.857-1.858.87-.349.004-.642-.082-.85-.29-.306-.307-.244-.714.042-1 .145-.146.32-.24.605-.301l.151-.028c.529-.08.991-.293 1.271-.573.425-.425.46-.818.197-1.08-.193-.194-.473-.155-.963.148l-.139.09-.71.476c-1.05.711-1.938.694-2.677-.045-.789-.79-.783-1.929-.026-2.957l.12-.154-.204-.203c-.242-.242-.121-.494.03-.646.138-.137.353-.246.57-.09l.073.062.214.214c.546-.435 1.14-.704 1.657-.71zM6.042 6.043a1 1 0 111.414 1.414 1 1 0 01-1.414-1.414z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Tag = /*#__PURE__*/forwardRef(IconTag);

export default Tag;
//# sourceMappingURL=Tag.js.map
